/* =========================================================
   EYESHELLS: engo-blog.js
   - Article/blog extras (related posts slider, etc.)
   - Runtime-safe init/cleanup for dynamic section reloads
   ========================================================= */

(function($){
  'use strict';

  if (!$) return;

  if (window.__esEngoBlogCleanup) {
    try { window.__esEngoBlogCleanup(); } catch (e) {}
  }

  var domReadyHandler = null;
  var pageShowHandler = null;
  var sectionHandlersBound = false;

  function initRelatedPosts(scope){
    var $scope = scope ? $(scope) : $(document);
    var $sliders = $scope.find('.js_relate_post');
    if (!$sliders.length || !$.fn || !$.fn.slick) return;

    $sliders.each(function(){
      var $el = $(this);
      if ($el.hasClass('slick-initialized')) return;
      try {
        $el.slick({
          dots: true,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 2,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 3 } },
            { breakpoint: 600, settings: { slidesToShow: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1, dots: false, arrows: true } }
          ]
        });
      } catch(e){}
    });
  }

  function onDomReady(){
    initRelatedPosts(document);
  }

  function onPageShow(){
    initRelatedPosts(document);
  }

  function bindSectionEvents(){
    if (sectionHandlersBound) return;
    sectionHandlersBound = true;
    document.addEventListener('shopify:section:load', onDomReady);
    document.addEventListener('shopify:section:select', onDomReady);
  }

  domReadyHandler = onDomReady;
  pageShowHandler = onPageShow;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', domReadyHandler);
  } else {
    onDomReady();
  }

  window.addEventListener('pageshow', pageShowHandler);
  bindSectionEvents();

  window.__esEngoBlogCleanup = function(){
    if (domReadyHandler) document.removeEventListener('DOMContentLoaded', domReadyHandler);
    if (pageShowHandler) window.removeEventListener('pageshow', pageShowHandler);
    if (sectionHandlersBound) {
      document.removeEventListener('shopify:section:load', onDomReady);
      document.removeEventListener('shopify:section:select', onDomReady);
      sectionHandlersBound = false;
    }
  };
})(window.jQuery);
